
  import { Vue, Component, Prop } from "vue-property-decorator";
  import moment from "moment";
  import SourcesMultiselect from "@/components/autocompleteMultiselects/SourcesMultiselect.vue";
  import TagMultiselect from "@/components/autocompleteMultiselects/TagMultiselect.vue";

  import Checkbox from "@/components/form/Checkbox.vue";
  import ModalFullScreen from "@/components/modal/ModalFullScreen.vue";
  import DropdownFilter from "@/components/filters/DropdownFilter.vue";
  import FormDatepicker from "@/components/form/FormDatepicker.vue";
  import UiButton from "@/components/button/ui-button.vue";
  import FormTextarea from "@/components/form/FormTextarea.vue";
  import FormGroup from "@/components/form/FormGroup.vue";
  import FormInputGroup from "@/components/form/FormInputGroup.vue";
  import { Resource_Information_Card, Source, Tag, User } from "@/generated/graphql";


  import ActivityDataForModal from "@/entities/modals/ActivityDataForModal";
  import { Contractor, Project } from "@/interface"; 
  import { NOTIFICATION } from "@/entities/Events";
  import Message from "@/data/notificationsMessages";
  import ModalContent from "@/components/modal/ModalContent.vue";
  import EDIT_RESOURCE_INFO_CARD from "@/apollo/contractors/UpdateContractorResourceinformation.gql"

  enum ValidationMsg {
    PROJECT_START = "contractor start date",
    PROJECT_END = "contractor end date",
  }

  interface ContractorDetails {
    contractor: Contractor;
    activeProjectsCount: number;
    completedProjectsCount: number;
   }

  @Component({
    components: {
      ModalContent,
      ModalFullScreen,
      DropdownFilter,
      FormDatepicker,
      UiButton,
      FormTextarea,
      FormGroup,
      FormInputGroup,
      SourcesMultiselect, 
      Checkbox,
      TagMultiselect,
    },

    })
  export default class EditResourceInformationModal extends Vue {
    @Prop({ type: Object, default: undefined }) readonly project?: Project;
    @Prop({ type: Object, default: null }) readonly projectActivity!: ActivityDataForModal | null;
    @Prop({ type: String, default: null }) readonly currentUserRole!: string;
    @Prop({ type: String, default: null }) readonly appliedTag!: string;
    @Prop({ type: String, default: null }) readonly appliedSourceFromGrid!: string;
    @Prop({ type: String, default: null }) readonly companyId!: string;
    @Prop({ type: Boolean, default: false }) readonly isEdittingLocked!: boolean;
    @Prop({ type: String, required: true}) readonly currentUserId!: string;
    @Prop({type: String, required: true }) readonly contractorId!: string;
    @Prop({ type: String, required: true }) readonly id!: string;
    @Prop({ type: String, required: true }) readonly note!: string;
    @Prop({ type: Number, required: true }) readonly rate!: number;
    @Prop({ type: String, required: true }) readonly profile_link!: string;
    @Prop({ type: String, required: true }) readonly from_date!: string;
    @Prop({ type: String, required: true }) readonly to_date!: string;
    @Prop({ type: Boolean, required: true }) readonly availability!: boolean;
    @Prop({ type: Object, default: undefined }) readonly appliedSource?: Source;


    @Prop({ type: Array, default: () => [] }) readonly resourceCard!: Resource_Information_Card[]
    notesp: string = this.note
    ratesp: number = this.rate
    profilelinkp: string = this.profile_link
    fromdatep: string = this.from_date
    todatep: string = this.to_date

  
    show: boolean =false;
    contractor: Contractor[] = [];
    contractorDetails?: ContractorDetails;
    selectedTagId: string | null = null;
    selectedSourceId: string | null = null;
    processing: boolean =false;
    contractor_id: string | null = null
    user_id: string | null = null
    edittnote: string = this.note
    selectedTagNewValue: string=''
    selectedappliedSourceNewValue: string=''
 
    tag? : Tag;
    source?: Source;
    user?: User;

    showAvailabilityCheckbox = {
      name: "Availability",
      id: "available",
      selected: true,
    }
    get queryArgs(): Object {
        return {
            id: this.contractorId,
        };
    }
    mounted(){
      this.selectedTagNewValue = this.appliedTag; 
      this.selectedappliedSourceNewValue = this.appliedSourceFromGrid;
    }
    appliedSourceId(): string | undefined {
      //@ts-ignore
      this.selectedappliedSourceNewValue =  this.appliedSource?.name;
      return this.appliedSource?.id;
    }
    get modalTitle(): string {
      return `${this.modalPurpose} Resource Information`;
    }
    get possibleEndDate(): Date | undefined {
      return moment("dddd, MMMM Dd YYYY").add(30, 'd').toDate();
    }
    get possibleStartDate(): Date | undefined {
      return moment("dddd, MMMM Dd YYYY").add(1, 'd').toDate();
    }
    get withContractor(): boolean {
      return Boolean(this.contractorId);
    }

    get modalPurpose(): string {
      return this.projectActivity?.id ? "Edit" : "Create";
    }

    get buttonText(): string {
      return  !this.projectActivity?.isNew
        ? "Update"
        : "Create";
    }

    closeModal(): void {
      this.$emit("close");
    }
    saveClick(): void {
      this.$emit("close");
    }
    //@ts-ignore
    setSourceId(sourceId: string): string {
      this.selectedSourceId = sourceId.length === 0 ? null : sourceId;
    }
    selectedTagNewValueFunc(val: any) {
      this.selectedTagNewValue = val;
    } 
    selectedappliedSourceNewValueFunc(val: any) {
      this.selectedappliedSourceNewValue = val;
    } 
    get startDateValidationRules(): string | object {
      //@ts-ignore
      const { from_date, to_date } = this.contractor;
      const noBeforeProjectStart = `noBefore:${from_date},${ValidationMsg.PROJECT_START}`;
      const noAfterProjectEnd = `noAfter:${to_date},${ValidationMsg.PROJECT_END}`;
      return `${noBeforeProjectStart}|${noAfterProjectEnd}|required_field`;
    }
    async onUpdate(): Promise<void> {    
      if (!this.contractorId) {
        return;
      }
      try { 
          this.processing = true;
          await this.$apollo.mutate({
            mutation: EDIT_RESOURCE_INFO_CARD,
            variables: {
              id: this.id,
                notes: this.notesp,
                rate: this.ratesp,
                from_date: this.fromdatep,
                to_date: this.todatep,
                availability: this.showAvailabilityCheckbox.selected,
                profile_link: this.profilelinkp,
                tag_id: this.selectedTagNewValue,
                source_id: this.selectedappliedSourceNewValue,
          }
          });
        this.$emit('add')
        this.$emit('refresh')
        this.$eventBus.emit(
          NOTIFICATION,
          Message.successMessage("Information editted  successfully")
        );
      } catch(err) {
        this.$eventBus.emit(
          NOTIFICATION,
          Message.errorMessage(err.message)
        );
      } finally {
        this.processing = false
        this.closeModal()
      }
    } 
  }
